import {GET_APPS, GET_SINGLE_APP, GET_FILTERED_APPS, GET_GLOBAL_MARKET_SINGLE_APP, UPLOAD_SINGLE_APK} from '../actions/marketActions';
import {
	FETCH_APPS_BEGIN,
	LOCAL_GET_SELECTED_APPS_BEGIN,
	LOCAL_GET_SELECTED_APPS_SUCCESS,
	FETCH_CHECKED_APPS_INFO_BEGIN,
	FETCH_CHECKED_APPS_INFO_SUCCESS,
	SAVE_RETAIL_CHECKED_APPS_BEGIN,
	SAVE_RETAIL_CHECKED_APPS_SUCCESS,
	GET_RETAIL_CHECKED_APPS_BEGIN,
	GET_RETAIL_CHECKED_APPS_SUCCESS
} from "../actions/marketActions";

const defaultAppState = {
	apps: [],
	pagination: {},
	loading: false,
	//error: null
};
const defaultSingleApp = {
	apks: []
};

const defaultCheckedAppsState = {
	checkedApps: [],
	loading: false,
};

const defaultCheckedAppsInfo = {
	checkedAppsInfo: [],
	loading: false,
};

const defaultInRetailAppsList = {
	inRetailAppsList: [],
	loading: false,
};

const defaultUploadProgress = {
	progressPercent: 0
};

export const appsList = (state = defaultAppState, action) => {
	switch (action.type) {
	case FETCH_APPS_BEGIN:
		return {
			...state,
			loading: true
		};
	case GET_APPS:
		return {
			...state,
			loading: false,
			apps: action.payload.apps,
			pagination: {
				numberOfElements : action.payload.numberOfElements,
				totalElements: action.payload.totalElements,
				totalPages: action.payload.totalPages
			},
		};

	default:
		return state;
	}
};

export const filteredAppsList = (state = defaultAppState, action) => {
	switch (action.type) {
	case GET_FILTERED_APPS:
		return {
			...state,
			apps: action.apps
		};
	default:
		return state;
	}
};

export const chosenApp = (state = defaultSingleApp, action) => {
	switch (action.type) {
	case GET_SINGLE_APP:
		return action.singleApp;

	default:
		return state;
	}
};

export const chosenAppFromGlobalMarket = (state = defaultSingleApp, action) => {
	switch (action.type) {
	case GET_GLOBAL_MARKET_SINGLE_APP:
		return action.singleGlobalMarketApp;

	default:
		return state;
	}
};


export const checkedAppsList = (state = defaultCheckedAppsState, action) => {
	switch (action.type) {
	case LOCAL_GET_SELECTED_APPS_BEGIN:
		return {
			...state,
			loading: true
		};
	case LOCAL_GET_SELECTED_APPS_SUCCESS:
		return {
			...state,
			loading: false,
			checkedApps: action.payload.checkedApps
		};

	default:
		return state;
	}
};

export const checkedAppsListInfo = (state = defaultCheckedAppsInfo, action) => {
	switch (action.type) {
	case FETCH_CHECKED_APPS_INFO_BEGIN:
		return {
			...state,
			loading: true
		};
	case FETCH_CHECKED_APPS_INFO_SUCCESS:
		return {
			...state,
			loading: false,
			checkedAppsInfo: action.payload.checkedAppsInfo
		};

	default:
		return state;
	}
};

export const getInRetailAppsList = (state = defaultInRetailAppsList, action) => {
	switch (action.type) {
	case GET_RETAIL_CHECKED_APPS_BEGIN:
		return {
			...state,
			loading: true
		};
	case GET_RETAIL_CHECKED_APPS_SUCCESS:
		return {
			...state,
			loading: false,
			inRetailAppsList: action.payload.inRetailAppsList
		};

	default:
		return state;
	}
};

export const getUploadProgress = (state = defaultUploadProgress, action) => {
	switch (action.type) {
	case UPLOAD_SINGLE_APK:
		return {
			...state,
			progressPercent: action.payload.progressPercent
		};

	default:
		return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/market.js